import { configureStore } from '@reduxjs/toolkit';
import authSlice from './authSlice';
import servicesSlice from './servicesSlice';
import companiesSlice from './companiesSlice';
import businessAreaSlice from './businessAreaSlice';
import forgotPasswordSlice from './forgotPasswordSlice';
import suggestionsSlice from './suggestionsSlice';
import customerSlice from './customerSlice';
import subscriptionSlice from './subscriptionSlice';
import dashboardSlice from './dashboardSlice';
import claimsSlice from './claimsSlice';
import notificationsSlice from './notificationsSlice';
import countriesSlice from './countriesSlice';
import organizationSlice from './organizationSlice';
import assistantsSlice from './assistantsSlice';
import activityLogSlice from './activityLogSlice';
import staffDirectorySlice from './staffDirectorySlice';
import contactMessagesSlice from './contactMessagesSlice';
import geminiConfigSlice from './geminiConfigSlice';
import cardPaymentsSlice from './cardPaymentsSlice';

export const store = configureStore({
  reducer: {
    user: authSlice,
    services: servicesSlice,
    companies: companiesSlice,
    claims: claimsSlice,
    businessAreas: businessAreaSlice,
    forgotPassword: forgotPasswordSlice,
    suggestions: suggestionsSlice,
    customers: customerSlice,
    abonnement: subscriptionSlice,
    dashboard: dashboardSlice,
    notifications: notificationsSlice,
    countries: countriesSlice,
    organization: organizationSlice,
    assistants: assistantsSlice,
    activityLog: activityLogSlice,
    staffDirectory: staffDirectorySlice,
    contactMessages: contactMessagesSlice,
    geminiConfig: geminiConfigSlice,
    cardPayments: cardPaymentsSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});
